import React, { useMemo, useState, useEffect } from "react"
import { FaEdit } from "react-icons/fa"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import TableContainer from "../../../components/Common/DataTableContainer"
import { fetchCategories } from "../../../redux/actions/event"

const PastList = () => {
  document.title = "Category List"

  const history = useNavigate()
  const dispatch = useDispatch()

  const categoryState = useSelector(state => state.event)

  const [categoryData, setCategoriesData] = useState([])

  const columns = useMemo(
    () => [
      {
        header: "Category Name",
        accessorKey: "title",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Description",
        accessorKey: "description",
        enableColumnFilter: false,
        enableSorting: true,
        // cell: info => (info.getValue() === 1 ? "Active" : "Inactive"),
      },
      {
        header: "Tags",
        accessorKey: "tags",
        enableColumnFilter: false,
        enableSorting: true,
        // cell: info => (info.getValue() === 1 ? "Active" : "Inactive"),
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => (info.getValue() === 1 ? "Active" : "Inactive"),
      },
      // {
      //   header: "Action",
      //   accessorKey: "action",
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   cell: info => {
      //     const row = info.row.original
      //     return (
      //       <div>
      //         <button
      //           className="btn btn-sm btn-primary me-2"
      //           onClick={() => history(`/events/edit-category/${row.url}`)}
      //           title="Edit Category"
      //         >
      //           <FaEdit />
      //         </button>
      //       </div>
      //     )
      //   },
      // },
    ],
    []
  )

  useEffect(() => {
    dispatch(fetchCategories({}))
  }, [dispatch])

  useEffect(() => {
    if (categoryState && Array.isArray(categoryState.eventCategoryList)) {
      setCategoriesData(categoryState.eventCategoryList)
    }
  }, [categoryState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex justify-content-between align-items-center mb-2 pb-2">
          <h2 className="nom-title mb-0">Event Categories</h2>
          <button
            className="primary-button"
            onClick={() => {
              history("/events/add-category")
            }}
          >
            Add category
          </button>
        </div>
        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={categoryData || []}
          isGlobalFilter={true}
          isPagination={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
        />
      </div>
    </div>
  )
}

export default PastList
